<div class="modal-wrapper">
  <div class="flex row title-row">
    <div class="modal-title">{{ 'Account deletion' | translate }}</div>
    <div class="icon-close" (click)="closeModal()">
      <i class="icon-X"></i>
    </div>
  </div>
  <div class="modal-description">
    {{ 'Are you sure you want to delete your account? This action cannot be undone, and all your data will be permanently removed.' | translate }}
  </div>
  <div class="flex row action-buttons">
    <app-button
      [ariaLabel]="'Cancel' | translate"
      [buttonStyleType]="ButtonTypes.SECONDARY_0"
      (click)="closeModal()"
    >{{ 'Cancel' | translate }}
    </app-button>
    <div class="delete-btn">
      <button
        aria-label="Delete account"
        mat-button
        [mat-dialog-close]="true"
      >{{ 'Delete account' | translate }}
      </button>
    </div>
  </div>
</div>
